import React from "react";
import PropTypes from "prop-types";
import { ListItem, ListItemText, ListItemIcon } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import "./purchase.css";

/*istanbul ignore next */
const SubscriptionCard = ({ subscription, onClick }) => {
  const displayName = subscription.isEgSubscription
    ? subscription.brandName
    : subscription.subscriptionName;

  return (
    <ListItem
      className="subscription-list-item"
      onClick={() => onClick(subscription)}
    >
      <ListItemIcon className="subscription-icon">
        <CurrencyExchangeOutlinedIcon />
      </ListItemIcon>
      <ListItemText
        primary={displayName}
        className="subscription-list-text"
        primaryTypographyProps={{ fontWeight: "bold" }}
      />
      <ChevronRightIcon className="subscription-arrow" />
    </ListItem>
  );
};

SubscriptionCard.propTypes = {
  subscription: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SubscriptionCard;
